import React, { Component } from 'react';
import Dialog from '../../../common/Dialog';
import InputText, { InputSelectNative } from '../../../common/Form';
import DatePickerCmp from '../../../common/DatePicker';
import { GroupCheckbox, GroupRadio, GroupSwitch, SingleCheckbox, SingleRadio, SingleSwitch } from '../../../common/RadioAndCheckbox';
import { Box, FormHelperText, Grid, Typography } from '@mui/material';
import { isEmpty } from 'lodash';
import Creatable from '../../../common/Creatable';
import { Fragment } from 'react';
import PhotoUpload from '../../../common/PhotoUpload';

class ArticlePics extends Component {
    state = { 
        article_photo: null,
        errors:{}
    }

    componentDidMount = () => {
        const { article } = this.props;
        console.log('====================================');
        console.log({article});
        console.log('====================================');
    }

    setPhotos = (name, list) => {
        console.log("[INFO] SETPHOTOS", name, list);
        
        this.setState({
            [name]:list
        })
    }
    validate = () => {
        let noError = true
        let errors = {} 
        // let required = [
        //     "article_photo",
        // ]

        // required.map(field => {
        //     if( !this.state[field] && isEmpty(this.state[field]) ) { // isEmpty doesn't work on dates, !doesn't work for arrays
        //         console.log(`${field} is empty`)
        //         noError =  false
        //         errors[field] = "Veuillez remplir ce Champ" 
        //     } else {
        //         errors[field] = "" 
        //     }
        // })

        this.setState({
            errors
        })
        return noError
    }

    handleSubmit = async () => {

        if( this.validate() ){
            let data = Object.assign({}, this.props.article)
            data.article_photo = this.state.article_photo
         
            await this.props.updateArticlePics(data)
                
            // // if NoErrors ...
            if(this.props.STATE.articles.error){
                this.props.notif("error",`Un problème est survenu: ${this.props.STATE.articles.error}`)
            } else { 
                this.props.notif("success", "l'article a été modifié")
                this.props.handleClose()
            }
        } else {
            this.props.notif("error", "Le formulaire contient des erreurs")
        }
    }
    
    render() {
        const { article } = this.props;
        console.log('====================================');
        console.log(this.state, this.props.article);
        console.log('====================================');
        return (
            <Dialog
                title={"Modifier l'article"}
                close={this.props.handleClose}
                submitAction={this.handleSubmit}
                appBar
                maxWidth="md"
            >
                {!isEmpty(this.props.article) &&
                <Grid container >
                    <Grid item xs={12}>
                        <Box p={1}>
                            <Typography color="primary" variant="button" style={{fontWeight: "bold"}}>Photo</Typography>
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Box p={1}>
                            <PhotoUpload saved={article.article_photo && `/photos/single/${article.article_photo.filename}`} id="front" label="Photo Face Avant" setPhoto={(pic) => this.setPhotos("article_photo", pic)} photos={this.state.article_photo === null ? [] : this.state.article_photo } error={this.state.errors.article_photo} />
                        </Box>
                    </Grid>
                </Grid>      
                }
            </Dialog>
        );
    }
}

export default ArticlePics;